export var docElement = document.documentElement;



// WEBPACK FOOTER //
// ./app/assets/javascripts/components/tinySlider/lib/helpers/docElement.js